import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { exhaustMap, filter } from 'rxjs/operators';
import { LangService } from '../../services/lang.service';

@Injectable({
  providedIn: 'root',
})
export class CountryTranslateService {
  countryList = new BehaviorSubject(null);
  countryList$: Observable<any> = this.countryList.asObservable().pipe(filter((v) => !!v));
  loadListEvent$ = new Subject();

  constructor(private http: HttpClient, private langService: LangService) {
    this.loadListEvent$.pipe(exhaustMap(() => this.getCountryList())).subscribe({
      next: (data) => {
        this.countryList.next(data);
      },
    });
  }

  loadCountyListIfNeed() {
    if (this.countryList.getValue()) {
      return;
    }
    this.loadListEvent$.next();
  }

  getCountries(): Observable<any> {
    return this.countryList.getValue()
      ? this.countryList
      : this.getCountryList();
  }

  private getCountryList() {
    return this.http.get(`assets/i18n/countries/country.list.${this.langService.lang}.json`);
  }
}
